function Pager() {
    var _self = this;
    var _pagerSelector;
    var _viewMode;
    var _loadPageCallback = function () {
        

        attachPopoverEvents();

        tpj(".socialItemDetails").click(function () {
            tpj(this).next('.shareBox').toggle();
            tpj(this).next('.shareBox').find('.sharemetoo').lazySocialButtons();
        });

        ////////////////////
        var $wlist = tpj('.listitem2').width();
        var $hlist = tpj('.listitem2').height();

        tpj('.liover').css({
            "width": 10 + "%",
            "height": 10 + "%",
            "background-color": "#0099cc",
            "position": "absolute",
            "top": $hlist / 2 + "px",
            "left": $wlist / 2 + "px",
            "opacity": 0.0,
        });
        tpj('.fav-icon').css({
            "top": $hlist / 2 - 11 + "px",
            "left": $wlist + "px",
        });
        tpj('.book-icon').css({
            "top": $hlist / 2 - 11 + "px",
            "left": -25 + "px",
        });

        tpj(".listitem2")
			.mouseenter(function () {
			    "use strict";
			    tpj(this).find('.liover').stop().animate({ "left": 10 + "%", "top": 10 + "%", "width": 80 + "%", "height": 80 + "%", "opacity": 0.5 });
			    tpj(this).find('.book-icon').stop().animate({ "left": $wlist / 2 - 42 + "px" });
			    tpj(this).find('.fav-icon').stop().animate({ "left": $wlist / 2 + 18 + "px" });


			})
			.mouseleave(function () {
			    "use strict";
			    tpj(this).find('.liover').stop().animate({ "left": $wlist / 2 + "px", "top": $hlist / 2 + "px", "width": 10 + "%", "height": 10 + "%", "opacity": 0.0 });
			    tpj(this).find('.book-icon').stop().animate({ "left": -25 + "px" });
			    tpj(this).find('.fav-icon').stop().animate({ "left": $wlist + "px" });

			});

        ///////////////////////

        var initFilters = "false";
        if (tpj('#init-filters').length > 0) {
            initFilters = tpj('#init-filters').val();
        }
        if (tpj.offerList) {
            tpj.offerList.initialize(true, initFilters);
        } else {
            _self.initialize();
        }
        tpj('.linkMap').click(function () {
            tpj('body').animate({ scrollTop: tpj(this).offset().top }, 500);
        });
        if (typeof initThumbnailSlider === "function") {
            initThumbnailSlider();
        }
        if (typeof initFeaturedHotel === "function") {
            initFeaturedHotel();
        }
        if (typeof initPopoverReviews === "function") {
            //Review Slider
            initPopoverReviews();
        }

        //Credit Calculator
        if (typeof pmtSimulator !== typeof undefined && pmtSimulator && pmtSimulator.simulator_app && tpj('.PmtSimulator').length > 0) {
            pmtSimulator.simulator_app.setPublicKey(PAGAMASTARDE_PUBLICKEY);
            pmtSimulator.simulatorApp.restartSimulatorsArray();
            pmtSimulator.simulator_app.init();
        }
        if (typeof icSimulator !== typeof undefined && icSimulator && tpj('.ic-simulator').length > 0) {
            icSimulator.refresh();
        }
        if (typeof icLiteSimulator !== typeof undefined && icLiteSimulator && tpj('.ic-lite-simulator').length > 0) {
            icLiteSimulator.refresh();
        }


        //EC Analytics send impressions
        if (tpj('.offer-item').length > 0 && window.ga && ga.loaded) {

            var resultsListName = tpj('#results-list-name').val() || "Lista No Definida";

            tpj('.offer-item').each(function (index) {
                var $this = tpj(this);
                ga('CanariasFull.ec:addImpression', {            // Provide product details in an impressionFieldObject.
                    'id': $this.data('hotelid'),                   // Product ID (string).
                    'name': $this.data('hotelname'), // Product name (string).
                    'category': $this.data('hotelcategory'),   // Product category (string).
                    'list': resultsListName,         // Product list (string).
                    'position': (index+1),                    // Product position (number).
                    
                });

            })
            ga('CanariasFull.send', 'pageview');  
            
            
        }


    };

    _self.initialize = function(listContainerSelector, loadPageCallback) {
        _pagerSelector = ".pager";

        if (listContainerSelector) {
            _pagerSelector = listContainerSelector + " " + _pagerSelector;
        }

        tpj(_pagerSelector).each(function() {
            var container = tpj(this);
            if (container.data("method") == "POST") {
                _attachBehavior(container);
            }
        });

        if (loadPageCallback) {
            _loadPageCallback = loadPageCallback;
        }

        return _self;
    };

    _self.refreshAfterDelete = function(itemsSelector) {
        var pager = tpj(_pagerSelector);

        var pagerContainer = pager.first();
        var currentPage = parseInt(pagerContainer.data("currentpage"));
        var itemsContainer = pagerContainer.data("contentcontainer");
        var thereIsMoreThanOnePage = pagerContainer.children().length > 0;

        if (tpj(itemsSelector, itemsContainer).length > 0 && thereIsMoreThanOnePage) {
            _loadPage(currentPage, pagerContainer);
        }
        else if (currentPage > 1) {
            _loadPage(currentPage - 1, pagerContainer);
        }
    };

    _self.refreshAfterAdd = function() {
        var pager = tpj(_pagerSelector);

        var pagerContainer = pager.first();
        var currentPage = parseInt(pagerContainer.data("currentpage"));

        _loadPage(currentPage, pagerContainer);
    };

    _self.refresh = function() {
        var pager = tpj(_pagerSelector);

        var pagerContainer = pager.first();
        var currentPage = parseInt(pagerContainer.data("currentpage"));

        _loadPage(1, pagerContainer);
    };

    _self.refreshCurrentPage = function() {
        var pager = tpj(_pagerSelector);

        var pagerContainer = pager.first();
        var currentPage = parseInt(pagerContainer.data("currentpage"));

        _loadPage(currentPage, pagerContainer);
    };

    _self.getActionParams = function() {
        return tpj.unparam(tpj(_pagerSelector).data("params"));
    };

    _self.setActionParams = function(param) {
        return tpj(_pagerSelector).data("params", tpj.param(param));
    };

    var _attachBehavior = function(container) {
        tpj(".page", container).click(function() {
            _loadPage(tpj(this).data("page"), container);
        });
    };

    var _loadPage = function (page, container) {
        var params = "page=" + page;
        var actionParams = container.data("params");
        if (actionParams != "") params += "&" + actionParams;
        
        if (container.data("method") == "POST") {
            _viewMode = tpj('.three-fourth article').attr("class");
            tpj.ajaxSettings.traditional = true;

            var _testparams = tpj.unparam(params);
            tpj(container.data("contentcontainer")).heavyLoad(container.data("controller") + "/" + container.data("action"), params, _loadPageCallback);
            tpj(document).scrollTop(tpj(container.data("contentcontainer")).offset().top - 100);
            parent.postMessage({ msgType: "scrollTo", y: tpj(container.data("contentcontainer")).offset().top - 100 }, '*');
        }
        else {
            var route = container.data("route");
            window.location = Environment_APP_PATH + (route != "" ? route : container.data("controller") + "/" + container.data("action")) + "?" + params;
        }
    };
}